<template>
  <div class="jd-button-box" :style="fatherStyle">
    <el-button
      :v-zoom="isZoom ? { from: zFormText, name: zNameText } : {}"
      @click.prevent="$emit('click')"
      :disabled="disabled"
      :class="['new-btn', typeClass, hasMinWidth, hasLightHight]"
      :style="
        btnWidth != '' 
          ? {width: btnWidth}
          :  styleObj
      "
      :loading="loading"
    >
      <slot>{{ label }}</slot>
    </el-button>
  </div>
</template>

<script>
export default {
  name: "jd-button",
  props: {
    loading:{
      type: Boolean,
      default: false,
    },
    isPrevent: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    isZoom: {
      type: Boolean,
      default: false,
    },
    // 按钮埋点参数
    zForm: {
      type: String,
      default: "",
    },
    zName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 按钮类型
     *  default    白色 悬停变灰
     *  break      黑色 悬停变灰黑
     *  blue       蓝色 悬停变浅蓝 （查询按钮）
     *  select     灰色 悬停变蓝色 （已选x个按钮）
     *  toBlue     白色 悬停变蓝
     *  gley       灰色 悬停变黑色字体 （重置按钮）
     *  text       黑色文字 悬停变深黑
     *  blueText   蓝色文字 悬停变浅蓝
     *  labelSelect 灰底 悬停变浅蓝
    *   disabledGrey 灰色 禁用 灰色底
    *   greyText  灰色文字
     */
    type: {
      type: String,
      default: "default",
      // validator: (value) =>
      //   ["default", "break", "blue", "text", "blueText",].includes(value),
    },
    // 按钮宽度
    // tip：传width的时候传styleTextObj是无效的
    /**     
     * 使用例子：
     * <jd-button
          :styleTextObj="{'border-radius': '4px', width: '80px'}"
          >关闭</jd-button
        >
        <jd-button
          width='80px'
          >关闭</jd-button
        >
    **/
    width: { 
      type: String,
      default: "",
    },
    fatherStyle: {
     type: [Object, String],
      default: () =>{},
    },
    styleTextObj: {
      type: Object,
      default: null,
    },
    // 是否设置最小宽度
    isMinWidth: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    typeClass() {
      if (this.type != "") {
        return `${this.type}-btn`;
      } else {
        return "default-btn";
      }
    },
    zFormText() {
      return this.zForm ? this.zForm : "";
    },
    zNameText() {
      return this.zName ? this.zName : "";
    },
    hasMinWidth() {
      if(this.type != 'text' && this.type != 'blueText' && this.isMinWidth) {
        return 'min-width';
      }else {
        return '';
      }
    },
    hasLightHight(){
      if(this.type != 'text' && this.type != 'blueText') {
        return 'line-height-box';
      }else {
        return '';
      }
    },
    btnWidth() {
      return this.width;
    },
    styleObj(){
      return this.styleTextObj ? this.styleTextObj : {};
    },
    textDisabled() {
      if((this.type == 'text' ||  this.type == 'blueText') && this.disabled) {
        return 'text-disabled';
      }else {
        return '';
      }
    }
  },
};
</script>

<style lang='scss' scoped>
.jd-button-box {
  display: inline-block;
  &+& {
    margin-left: 8px;
  }
  .new-btn {
    padding: 0 16px;
    border-radius: 2px;
    font-size: 14px;
    height: auto;
  }
  .break-btn {
    color: #ffffff;
    background: #3159FF;
    border: 1px solid #3159FF;
    border-radius: 2px;
    font-weight: 400px;
    &:hover {
      background: #2B50E6;
      border: 1px solid #2B50E6;
      border-radius: 2px;
    }
    &:focus {
      background: #002DCC;
      border: 1px solid #2768FF;
      border-radius: 2px;
    }
    &.is-disabled{
      color: #FFFFFF;
      background: #BFBFBF;
      border-radius: 2px;
      border: 1px solid #BFBFBF;
    }
  }
  .default-btn {
    background: #ffffff;
    border: 1px solid #dcdfe6;
    color: #666666;
    &:hover {
      border: 1px solid #f2f3f5;
      color: #666666;
      background: #f2f3f5;
    }
  }
  .blue-btn {
    background: rgba(39, 104, 255, 0.1);
    color: #2768ff;
    border: none;
    &:hover {
      color: #5286ff;
      background: rgba(39, 104, 255, 0.1);
    }
    &.is-disabled{
      color: #999999;
      background: #f2f3f5;
    }
  }
  .select-btn {
    background: #f2f3f5;
    color: #666666;
    border: none;
    border: 1px solid #f2f3f5;
    &:hover {
      color: #5286ff;
      background: rgba(39, 104, 255, 0.1);
    }
  }
  .gley-btn {
    background: #f2f3f5;
    color: #666666;
    border: none;
    // border: 1px solid #f2f3f5;
    &:hover {
      background: #f2f3f5;
      color: #000;
      // border: 1px solid #f2f3f5;
    }
  }
  .text-btn {
    color: #666666;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      color: #1f1f1f;
    }
  }
  .blueText-btn {
    color: #2768ff;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      color: #5286ff;
    }
  }
  .labelSelect-btn {
    background: #F5F5F7;
    border: none;
    &:hover {
      background: rgba(39, 104, 255, 0.1);
      color: #2768ff;
      border: none;
    }
  }
  .disabledGrey-btn {
    background: #f2f3f5;
    color: #cccccc;
    border: none;
    // border: 1px solid #f2f3f5;
    &:hover {
      background: #f2f3f5;
      color: #cccccc;
      // border: 1px solid #f2f3f5;
    }
  }
  .greyText-btn {
    background: transparent;
    color: #cccccc;
    border: none;
    // border: 1px solid #f2f3f5;
    &:hover {
      background: transparent;
      color: #cccccc;
      // border: 1px solid #f2f3f5;
    }
  }
  .toBlue-btn {
    background: #F2F3F5;
    border: none;
    &:hover {
      background: rgba(39,104,255,0.1);
      color: #2768FF;
      border: none;
    }
  }
  .min-width {
    min-width: 68px;
  }
  .line-height-box {
    line-height: 32px;
  }
  .text-disabled {
    color: #999999;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      color: #999999;
    }
  }
}
</style>